import "../css/Inicio.css";
import Navbar1 from "../components/Navbar1";
import Navbar2 from "../components/Navbar2";
import Panel_Servicios from "../components/Panel_Servicios";
import Footer from "../components/Footer";

export default function Servicios() {
  return (
    <div className="panelPrincipal">
      <Navbar1 />
      <Navbar2 />
      <Panel_Servicios />
      <Footer />
    </div>
  );
}
